import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import DynamicOrderForm from "./DynamicOrderForm";
import CelebrationCakeForm from "./CelebrationCakeForm";
import { getOrderById } from "../../services/OrderService";

const CelebrationCakeTypes = ["celebration-cake", "Celebration Cake"];

const OrderFormRouter: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [orderType, setOrderType] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchType = async () => {
      if (!id) {
        setLoading(false);
        return;
      }
      try {
        const order = await getOrderById(parseInt(id, 10));
        if (order) {
          setOrderType(order.type || "");
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchType();
  }, [id]);

  if (loading) {
    return (
      <div className="page-wrapper-center">
        <Spinner animation="border" />
      </div>
    );
  }

  if (orderType && CelebrationCakeTypes.includes(orderType)) {
    return <CelebrationCakeForm />;
  }

  return <DynamicOrderForm />;
};

export default OrderFormRouter;
